import React from "react";
import T from "prop-types";
import { Map } from "immutable";
import { ToggleSwitch } from "MODULES/shared/containers";
import { Icon } from "MODULES/shared/components";
import DropDownItem from "MODULES/shared/components/DropDown/DropDownItem";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import Form from "./Form";

export default function EditInvoiceDetails({ repairOrder }) {
  if (repairOrder.get("cancelled")) {
    return false;
  }

  return (
    <ToggleSwitch>
      {(visible, open, close) => (
        <DropDownItem onClick={open}>
          <Icon name="dollar" fixed />
          &nbsp;Edit Billing
          <Modal open={visible} close={close} dialogClass="modal-lg">
            <Header>
              <Close close={close} />
              <h4 className="modal-title">Edit Billing Details</h4>
            </Header>
            <Form
              close={close}
              repairOrder={repairOrder.toJS()}
              initialValues={Object.assign(repairOrder.toJS(), {
                invoice_paid_date: null,
                invoice_number: null
              })}
            />
          </Modal>
        </DropDownItem>
      )}
    </ToggleSwitch>
  );
}

EditInvoiceDetails.propTypes = {
  repairOrder: T.instanceOf(Map).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/EditInvoiceDetails/EditInvoiceDetails.jsx